import axios from '@/axiosInstance.ts'
import {ResponseTypeParam} from '@/types'

/*Update freelancer*/
export interface HttpUpdateFreelancerOptionsAvailabilityPayload {
    shoot_available: boolean
    region: string | null
}
export interface HttpUpdateFreelancerOptionsProfilePhotoPayload {
    profile_photo_url: string | null
}
export interface HttpUpdateFreelancerOptionsDescriptionPayload {
    description: string
}

export interface HttpUpdateFreelancerOptions {
    urlParams: {userId: number}
    payload:
        | HttpUpdateFreelancerOptionsAvailabilityPayload
        | HttpUpdateFreelancerOptionsProfilePhotoPayload
        | HttpUpdateFreelancerOptionsDescriptionPayload
}
export const httpUpdateFreelancer = ({payload, urlParams}: HttpUpdateFreelancerOptions) =>
    axios.patch(`/photographers/${urlParams.userId}/update`, payload)

/*Upload freelancer profile photo*/
interface HttpUploadFreelancerProfilePhotoOptions {
    urlParams: {userId: number}
    payload: FormData
}
export const httpUploadFreelancerProfilePhoto = ({urlParams, payload}: HttpUploadFreelancerProfilePhotoOptions) =>
    axios.post(`/photographers/${urlParams.userId}/profile-photo`, payload, {
        headers: {'Content-Type': 'multipart/form-data'}
    })

/*Change SMS option*/
export interface HttpChangeOptionSmsOptions {
    payload: {
        send_notifications_to_phone: boolean
    }
}
export const httpChangeOptionSms = ({payload}: HttpChangeOptionSmsOptions) =>
    axios.put('/navigate/photographers/settings/phone-number/notification', payload)

/*Google authentication*/
export interface HttpGoogleAuthOptions {
    params: {
        code: string
        state: string
    }
}
export const httpGoogleAuth = ({params}: HttpGoogleAuthOptions) => axios.get('/node/v1/google-oauth/callback', {params})

export interface HttpGoogleLogoutOptions {
    payload: {
        photographerId: number
    }
}
export const httpGoogleLogout = ({payload}: HttpGoogleLogoutOptions) =>
    axios.post('/node/v1/google-oauth/logout', payload)

/*Change freelancer address and areas*/
export interface HttpUpdateFreelancerAddressPayload {
    latitude: string
    longitude: string
    address: string
    country: string
}
export interface HttpUpdateFreelancerAddressOptions {
    urlParams: {userId: number}
    payload: HttpUpdateFreelancerAddressPayload
    params: ResponseTypeParam
}
export const httpUpdateFreelancerAddress = ({payload, urlParams, params}: HttpUpdateFreelancerAddressOptions) =>
    axios.patch(`/navigate/photographers/${urlParams.userId}/update-address`, payload, {params})

export interface HttpDeleteFreelancerAreaOptions {
    urlParams: {userId: number; areaId: number}
    params: ResponseTypeParam
}
export const httpDeleteFreelancerArea = ({urlParams, params}: HttpDeleteFreelancerAreaOptions) =>
    axios.delete(`/navigate/photographers/${urlParams.userId}/geos/${urlParams.areaId}`, {params})

export interface HttpFreelancerAreasOptions {
    urlParams: {userId: number}
    payload: {
        geo_ids: number[]
    }
}
export const httpFreelancerAreas = ({payload, urlParams}: HttpFreelancerAreasOptions) =>
    axios.patch(`/navigate/photographers/${urlParams.userId}/geos/bulk`, payload)

interface HttpGeoSelectOptions {
    params: {countries: string[]} | {region: string} | {extended_country: string}
}
export const httpGeoSelect = ({params}: HttpGeoSelectOptions) => axios.get('/geoSelect', {params})
/* Email changing */
export interface HttpChangeFreelancerEmailOption {
    payload: {
        new_email: string
        password: string
    }
    params: ResponseTypeParam
}
export const httpChangeFreelancerEmail = ({payload, params}: HttpChangeFreelancerEmailOption) =>
    axios.post('/navigate/photographers/settings/email', payload, {params})

export interface HttpDeleteNewEmailRequestOption {
    params: ResponseTypeParam
}
export const httpDeleteNewEmailRequest = ({params}: HttpDeleteNewEmailRequestOption) =>
    axios.delete('/navigate/photographers/settings/email', {params})

export interface HttpResendConfirmationEmailOption {
    params: ResponseTypeParam
}
export const httpResendConfirmationEmail = ({params}: HttpResendConfirmationEmailOption) =>
    axios.post('/navigate/photographers/settings/email/resend-confirmation', {params})

export interface HttpConfirmEmailRequestOption {
    params: {
        token: string
    }
}
export const httpConfirmEmailRequest = ({params}: HttpConfirmEmailRequestOption) =>
    axios.put('/navigate/photographers/settings/change/email', null, {params})

/*Change user phone number*/
export interface HttpRequestVerificationCodeOptions {
    payload: {
        phone: string
    }
}

export const httpRequestVerificationPhoneCode = ({payload}: HttpRequestVerificationCodeOptions) =>
    axios.post('/navigate/photographers/settings/phone-number', payload)

export interface HttpValidateVerificationPhoneCodeOptions {
    payload: {
        verification_code: number
    }
}

export const httpValidateVerificationPhoneCode = ({payload}: HttpValidateVerificationPhoneCodeOptions) =>
    axios.post('/navigate/photographers/settings/phone-number/verify', payload)

export const httpResendVerificationPhoneCode = () =>
    axios.post('/navigate/photographers/settings/phone-number/resend-verification-code')
